import { zipSync } from 'fflate';

/*
zipList:  Object with keys as a path of each filename and the value being a uint8 representation of the data
*/
const zip = (zipList) => {
    const zippedData = zipSync(zipList);
    return zippedData;
}

export {zip}